/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

export default class WorkflowsInspectRoute extends ReactRoute(Route) {
  analytics = {
    place: 'workflows-troubleshoot-conversations',
    section: 'automation',
  };

  reactEnabled(): boolean {
    return true;
  }

  model(params: { conversation_id?: string }) {
    return {
      conversationId: params.conversation_id,
    };
  }
}
